import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import axiosInstance from "../axiosInterceptor";
import "./dashboard.scss";
import { useNavigate } from "react-router-dom";
import { FaShoppingCart, FaClock, FaUndo, FaUserTie } from "react-icons/fa";

const Dashboard = () => {
  const cardStyle = (bg) => ({
    background: bg,
    borderRadius: "12px",
    border: "none",
  });

  const iconStyle = {
    fontSize: "22px",
    marginRight: "10px",
  };

  const [countingData, setCountingData] = useState(null);
  const [loading, setLoading] = useState(true);
    const [registrationData, setRegistrationData] = useState(null);
 const [questionaskData, setQuestionaskData] = useState(null);
 const [unsolvedqueData, setUnsolvedquekData] = useState(null);
  const [anserqueData, setAnserquekData] = useState(null);
  const navigator = useNavigate();

useEffect(() => {
  setLoading(true);

  axiosInstance.get("admin/dashboard/counting")
    .then(res => res.data.isSuccess && setCountingData(res.data))
    .catch(console.error);

  axiosInstance.get("admin/dashboard/countRegistration")
    .then(res => res.data.isSuccess && setRegistrationData(res.data))
    .catch(console.error);

  axiosInstance.get("admin/dashboard/questionAsked")
    .then(res => res.data.isSuccess && setQuestionaskData(res.data))
    .catch(console.error);

  axiosInstance.get("admin/dashboard/unsolvedQuestion")
    .then(res => res.data.isSuccess && setUnsolvedquekData(res.data))
    .catch(console.error);

  axiosInstance.get("admin/dashboard/answerQuestion")
    .then(res => res.data.isSuccess && setAnserquekData(res.data))
    .catch(console.error);

  setLoading(false);
}, []);
  return (
    <div className="mt-4 mb-4">
      {loading ? (
        <div className="loader">Loading...</div>
      ) : (
        <>
          <div className="dashboard-page">
            <Row>
              <Col md="3">
                <Card style={cardStyle("#fff")} className="p-3">
                  <CardBody>
                    <div className="d-flex align-items-center">
                      <FaShoppingCart
                        style={{ ...iconStyle, color: "#7C3AED" }}
                      />
                      <p className="dashboard-title mb-0">Orders</p>
                    </div>

                    <h5
                      className="mt-2"
                      style={{ cursor: "pointer", color: "#7C3AED" }}
                      onClick={() => navigator("/orders")}
                    >
                      {countingData?.totalOrderPaid} / $
                      {countingData?.totalPaidSum}
                    </h5>
                  </CardBody>
                </Card>
              </Col>

              <Col md="3">
                <Card style={cardStyle("#fff")} className="p-3">
                  <CardBody>
                    <div className="d-flex align-items-center">
                      <FaClock style={{ ...iconStyle, color: "#D97706" }} />
                      <p className="dashboard-title mb-0">Unpaid</p>
                    </div>

                    <h5
                      className="mt-2"
                      style={{ cursor: "pointer", color: "#D97706" }}
                      onClick={() => navigator("/orders")}
                    >
                      {countingData?.totalOrderUnpaid} / $
                      {countingData?.totalUnpaidSum}
                    </h5>
                  </CardBody>
                </Card>
              </Col>

              <Col md="3">
                <Card style={cardStyle("#fff")} className="p-3">
                  <CardBody>
                    <div className="d-flex align-items-center">
                      <FaUndo style={{ ...iconStyle, color: "#DC2626" }} />
                      <p className="dashboard-title mb-0">Refunded</p>
                    </div>

                    <h5
                      className="mt-2"
                      style={{ cursor: "pointer", color: "#DC2626" }}
                      onClick={() => navigator("/orders")}
                    >
                      {countingData?.totalOrderRefund} / $
                      {countingData?.totalRefundSum}
                    </h5>
                  </CardBody>
                </Card>
              </Col>

              <Col md="3">
                <Card style={cardStyle("#fff")} className="p-3">
                  <CardBody>
                    <div className="d-flex align-items-center">
                      <FaUserTie style={{ ...iconStyle, color: "#0284C7" }} />
                      <p className="dashboard-title mb-0">Tutor</p>
                    </div>

                    <h5 className="mt-2" style={{ color: "#0284C7" }}>
                      {countingData?.totalOrderTutorPaid} / $
                      {countingData?.totalTutorPaidSum}
                    </h5>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
          <div className="count-registration mt-3">
            <Row>
              <Col md="6">
                <Card>
                  <CardBody>
                    <div className="card-title">
                      <div className="mt-2 font-weight-bold">
                        Student Registration
                      </div>
                    </div>
                    <div className="template-demo scroll-table">
                      <table className="table table-striped mb-0">
                        <thead>
                          <tr>
                            <th className="pl-0">Today</th>
                            <th
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                            >
                              {registrationData &&
                                registrationData.studentRegistration.today}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="pl-0">Last 7 Days</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED " }}
                            >
                              {registrationData &&
                                registrationData.studentRegistration.last7Days}
                            </td>
                          </tr>
                          <tr>
                            <td className="pl-0">Last 30 Days</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED " }}
                            >
                              {registrationData &&
                                registrationData.studentRegistration.last30Days}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col md="6">
                <Card>
                  <CardBody>
                    <div className="card-title">
                      <div className="mt-2 font-weight-bold">
                        Tutor Registration
                      </div>
                    </div>
                    <div className="template-demo scroll-table">
                      <table className="table table-striped mb-0">
                        <thead>
                          <tr>
                            <th className="pl-0">Today</th>
                            <th
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED " }}
                            >
                              {registrationData &&
                                registrationData.tutorRegistration.today}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="pl-0">Last 7 Days</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED " }}
                            >
                              {registrationData &&
                                registrationData.tutorRegistration.last7Days}
                            </td>
                          </tr>
                          <tr>
                            <td className="pl-0">Last 30 Days</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED " }}
                            >
                              {registrationData &&
                                registrationData.tutorRegistration.last30Days}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
          <div className="question-ask mt-3">
            <div className="bg-white p-2 mb-2" style={{ borderRadius: "5px" }}>
              <h5 className="page-title">Question Ask</h5>
            </div>
            <Row>
              <Col md="4">
                <Card>
                  <CardBody>
                    <div className="card-title">
                      <div className="mt-2 font-weight-bold">Homework Help</div>
                    </div>
                    <div className="template-demo scroll-table">
                      <table className="table table-striped  mb-0">
                        <thead>
                          <tr>
                            <th className="pl-0">Today</th>
                            <th
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/homework-list");
                              }}
                            >
                              {questionaskData &&
                                questionaskData.questionsAskedForHomeworkHelp
                                  .today}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="pl-0">Last 7 Days</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/homework-list");
                              }}
                            >
                              {questionaskData &&
                                questionaskData.questionsAskedForHomeworkHelp
                                  .last7Days}
                            </td>
                          </tr>
                          <tr>
                            <td className="pl-0">Last 30 Days</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/homework-list");
                              }}
                            >
                              {questionaskData &&
                                questionaskData.questionsAskedForHomeworkHelp
                                  .last30Days}
                            </td>
                          </tr>
                          <tr>
                            <td className="pl-0">Life Time</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/homework-list");
                              }}
                            >
                              {questionaskData &&
                                questionaskData.questionsAskedForHomeworkHelp
                                  .lifeTime}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card>
                  <CardBody>
                    <div className="card-title">
                      <div className="mt-2 font-weight-bold">
                        Assignment Help
                      </div>
                    </div>
                    <div className="template-demo scroll-table">
                      <table className="table table-striped mb-0">
                        <thead>
                          <tr>
                            <th className="pl-0">Today</th>
                            <th
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/assignment-list");
                              }}
                            >
                              {questionaskData &&
                                questionaskData.questionsAskedForAssignmentHelp
                                  .today}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="pl-0">Last 7 Days</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/assignment-list");
                              }}
                            >
                              {questionaskData &&
                                questionaskData.questionsAskedForAssignmentHelp
                                  .last7Days}
                            </td>
                          </tr>
                          <tr>
                            <td className="pl-0">Last 30 Days</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/assignment-list");
                              }}
                            >
                              {questionaskData &&
                                questionaskData.questionsAskedForAssignmentHelp
                                  .last30Days}
                            </td>
                          </tr>
                          <tr>
                            <td className="pl-0">Life Time</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/assignment-list");
                              }}
                            >
                              {questionaskData &&
                                questionaskData.questionsAskedForAssignmentHelp
                                  .lifeTime}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card>
                  <CardBody>
                    <div className="card-title">
                      <div className="mt-2 font-weight-bold">
                        Live Session Help
                      </div>
                    </div>
                    <div className="template-demo scroll-table">
                      <table className="table table-striped mb-0">
                        <thead>
                          <tr>
                            <th className="pl-0">Today</th>
                            <th
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/live-session-list");
                              }}
                            >
                              {questionaskData &&
                                questionaskData.questionsAskedForLiveSessionHelp
                                  .today}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="pl-0">Last 7 Days</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/live-session-list");
                              }}
                            >
                              {questionaskData &&
                                questionaskData.questionsAskedForLiveSessionHelp
                                  .last7Days}
                            </td>
                          </tr>
                          <tr>
                            <td className="pl-0">Last 30 Days</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/live-session-list");
                              }}
                            >
                              {questionaskData &&
                                questionaskData.questionsAskedForLiveSessionHelp
                                  .last30Days}
                            </td>
                          </tr>
                          <tr>
                            <td className="pl-0">Life Time</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/live-session-list");
                              }}
                            >
                              {questionaskData &&
                                questionaskData.questionsAskedForLiveSessionHelp
                                  .lifeTime}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>

          <div className="question-subCategory mt-3">
            <div className="bg-white p-2 mb-2" style={{ borderRadius: "5px" }}>
              <h5 className="page-title">Category Wise Questions</h5>
            </div>
            <Row>
              <Col md="4">
                <Card>
                  <CardBody>
                    <div className="card-title">
                      <div className="mt-2 font-weight-bold">Homework Help</div>
                    </div>
                    <div className="template-demo scroll-table">
                      <table className="table table-striped mb-0 ">
                        <tbody>
                          {questionaskData &&
                            questionaskData.subCategoryWiseQuestionsAskedForHomeworkHelp?.map(
                              (subCategory) => (
                                <tr key={subCategory._id}>
                                  <td className="pl-0">
                                    {subCategory.subCategoryName}
                                  </td>
                                  <td
                                    className="text-right font-weight-bold"
                                    style={{
                                      color: "#E541ED ",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      navigator("/homework-list");
                                    }}
                                  >
                                    {subCategory.totalOrder}
                                  </td>
                                </tr>
                              ),
                            )}
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card>
                  <CardBody>
                    <div className="card-title">
                      <div className="mt-2 font-weight-bold">
                        Assignment Help
                      </div>
                    </div>
                    <div className="template-demo scroll-table">
                      <table className="table table-striped mb-0">
                        <tbody>
                          {questionaskData &&
                            questionaskData.subCategoryWiseQuestionsAskedForAssignmentHelp?.map(
                              (subCategory) => (
                                <tr key={subCategory._id}>
                                  <td className="pl-0">
                                    {subCategory.subCategoryName}
                                  </td>
                                  <td
                                    className="text-right font-weight-bold"
                                    style={{
                                      color: "#E541ED ",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      navigator("/assignment-list");
                                    }}
                                  >
                                    {subCategory.totalOrder}
                                  </td>
                                </tr>
                              ),
                            )}
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card>
                  <CardBody>
                    <div className="card-title">
                      <div className="mt-2 font-weight-bold">
                        Live Session Help
                      </div>
                    </div>
                    <div className="template-demo scroll-table">
                      <table className="table table-striped mb-0">
                        <tbody>
                          {questionaskData &&
                            questionaskData.subCategoryWiseQuestionsAskedForLiveSessionHelp?.map(
                              (subCategory) => (
                                <tr key={subCategory._id}>
                                  <td className="pl-0">
                                    {subCategory.subCategoryName}
                                  </td>
                                  <td
                                    className="text-right font-weight-bold"
                                    style={{
                                      color: "#E541ED ",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      navigator("/live-session-list");
                                    }}
                                  >
                                    {subCategory.totalOrder}
                                  </td>
                                </tr>
                              ),
                            )}
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
          <div className="questionunsolved-ask mt-3">
            <div className="bg-white p-2 mb-2" style={{ borderRadius: "5px" }}>
              <h5 className="page-title">Unsolved Question</h5>
            </div>
            <Row>
              <Col md="4">
                <Card>
                  <CardBody>
                    <div className="card-title">
                      <div className="mt-2 font-weight-bold">Homework Help</div>
                    </div>
                    <div className="template-demo scroll-table">
                      <table className="table table-striped mb-0">
                        <thead>
                          <tr>
                            <th className="pl-0">Today</th>
                            <th
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/homework-list");
                              }}
                            >
                              {unsolvedqueData &&
                                unsolvedqueData.unsolvedQuestionForHomeworkHelp
                                  ?.today}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="pl-0">Last 7 Days</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/homework-list");
                              }}
                            >
                              {unsolvedqueData &&
                                unsolvedqueData.unsolvedQuestionForHomeworkHelp
                                  ?.last7Days}
                            </td>
                          </tr>
                          <tr>
                            <td className="pl-0">Last 30 Days</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/homework-list");
                              }}
                            >
                              {unsolvedqueData &&
                                unsolvedqueData.unsolvedQuestionForHomeworkHelp
                                  ?.last30Days}
                            </td>
                          </tr>
                          <tr>
                            <td className="pl-0">Life Time</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/homework-list");
                              }}
                            >
                              {unsolvedqueData &&
                                unsolvedqueData.unsolvedQuestionForHomeworkHelp
                                  ?.lifeTime}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card>
                  <CardBody>
                    <div className="card-title">
                      <div className="mt-2 font-weight-bold">
                        Assignment Help
                      </div>
                    </div>
                    <div className="template-demo scroll-table">
                      <table className="table table-striped mb-0">
                        <thead>
                          <tr>
                            <th className="pl-0">Today</th>
                            <th
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/assignment-list");
                              }}
                            >
                              {unsolvedqueData &&
                                unsolvedqueData
                                  .unsolvedQuestionForAssignmentHelp?.today}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="pl-0">Last 7 Days</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/assignment-list");
                              }}
                            >
                              {unsolvedqueData &&
                                unsolvedqueData
                                  .unsolvedQuestionForAssignmentHelp?.last7Days}
                            </td>
                          </tr>
                          <tr>
                            <td className="pl-0">Last 30 Days</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/assignment-list");
                              }}
                            >
                              {unsolvedqueData &&
                                unsolvedqueData
                                  .unsolvedQuestionForAssignmentHelp
                                  ?.last30Days}
                            </td>
                          </tr>
                          <tr>
                            <td className="pl-0">Life Time</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/assignment-list");
                              }}
                            >
                              {unsolvedqueData &&
                                unsolvedqueData
                                  .unsolvedQuestionForAssignmentHelp?.lifeTime}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card>
                  <CardBody>
                    <div className="card-title">
                      <div className="mt-2 font-weight-bold">
                        Live Session Help
                      </div>
                    </div>
                    <div className="template-demo scroll-table">
                      <table className="table table-striped mb-0">
                        <thead>
                          <tr>
                            <th className="pl-0">Today</th>
                            <th
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/live-session-list");
                              }}
                            >
                              {unsolvedqueData &&
                                unsolvedqueData
                                  .unsolvedQuestionForLiveSessionHelp?.today}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="pl-0">Last 7 Days</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/live-session-list");
                              }}
                            >
                              {unsolvedqueData &&
                                unsolvedqueData
                                  .unsolvedQuestionForLiveSessionHelp
                                  ?.last7Days}
                            </td>
                          </tr>
                          <tr>
                            <td className="pl-0">Last 30 Days</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/live-session-list");
                              }}
                            >
                              {unsolvedqueData &&
                                unsolvedqueData
                                  .unsolvedQuestionForLiveSessionHelp
                                  ?.last30Days}
                            </td>
                          </tr>
                          <tr>
                            <td className="pl-0">Life Time</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/live-session-list");
                              }}
                            >
                              {unsolvedqueData &&
                                unsolvedqueData
                                  .unsolvedQuestionForLiveSessionHelp?.lifeTime}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
          <div className="questionunsolved-subCategory mt-4">
            <div className="bg-white p-2 mb-2">
              <h5 className="page-title">Category Wise Unsolved Questions</h5>
            </div>
            <Row>
              <Col md="4">
                <Card>
                  <CardBody>
                    <div className="card-title">
                      <div className="mt-2 font-weight-bold">Homework Help</div>
                    </div>
                    <div className="template-demo scroll-table">
                      <table className="table table-striped mb-0">
                        <tbody>
                          {unsolvedqueData &&
                            unsolvedqueData.subCategoryWiseUnsolvedQuestionsAskedForHomeworkHelp?.map(
                              (subCategory) => (
                                <tr key={subCategory._id}>
                                  <td className="pl-0">
                                    {subCategory.subCategoryName}
                                  </td>
                                  <td
                                    className="text-right font-weight-bold"
                                    style={{
                                      color: "#E541ED ",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      navigator("/homework-list");
                                    }}
                                  >
                                    {subCategory.totalOrder}
                                  </td>
                                </tr>
                              ),
                            )}
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card>
                  <CardBody>
                    <div className="card-title">
                      <div className="mt-2 font-weight-bold">
                        Assignment Help
                      </div>
                    </div>
                    <div className="template-demo scroll-table">
                      <table className="table table-striped mb-0">
                        <tbody>
                          {unsolvedqueData &&
                            unsolvedqueData.subCategoryWiseUnsolvedQuestionsAskedForAssignmentHelp?.map(
                              (subCategory) => (
                                <tr key={subCategory._id}>
                                  <td className="pl-0">
                                    {subCategory.subCategoryName}
                                  </td>
                                  <td
                                    className="text-right font-weight-bold"
                                    style={{
                                      color: "#E541ED ",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      navigator("/assignment-list");
                                    }}
                                  >
                                    {subCategory.totalOrder}
                                  </td>
                                </tr>
                              ),
                            )}
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card>
                  <CardBody>
                    <div className="card-title">
                      <div className="mt-2 font-weight-bold">
                        Live Session Help
                      </div>
                    </div>
                    <div className="template-demo scroll-table">
                      <table className="table table-striped mb-0">
                        <tbody>
                          {unsolvedqueData &&
                            unsolvedqueData.subCategoryWiseUnsolvedQuestionsAskedForLiveSessionHelp?.map(
                              (subCategory) => (
                                <tr key={subCategory._id}>
                                  <td className="pl-0">
                                    {subCategory.subCategoryName}
                                  </td>
                                  <td
                                    className="text-right font-weight-bold"
                                    style={{
                                      color: "#E541ED ",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      navigator("/live-session-list");
                                    }}
                                  >
                                    {subCategory.totalOrder}
                                  </td>
                                </tr>
                              ),
                            )}
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
          <div className="answer-ask mt-3">
            <div className="bg-white p-2 mb-2" style={{ borderRadius: "5px" }}>
              <h5 className="page-title">Answer Question</h5>
            </div>
            <Row>
              <Col md="4">
                <Card>
                  <CardBody>
                    <div className="card-title">
                      <div className="mt-2 font-weight-bold">Homework Help</div>
                    </div>
                    <div className="template-demo scroll-table">
                      <table className="table table-striped mb-0">
                        <thead>
                          <tr>
                            <th className="pl-0">Today</th>
                            <th
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/homework-list");
                              }}
                            >
                              {anserqueData &&
                                anserqueData.answerQuestionForHomeworkHelp
                                  ?.today}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="pl-0">Last 7 Days</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/homework-list");
                              }}
                            >
                              {anserqueData &&
                                anserqueData.answerQuestionForHomeworkHelp
                                  ?.last7Days}
                            </td>
                          </tr>
                          <tr>
                            <td className="pl-0">Last 30 Days</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/homework-list");
                              }}
                            >
                              {anserqueData &&
                                anserqueData.answerQuestionForHomeworkHelp
                                  ?.last30Days}
                            </td>
                          </tr>
                          <tr>
                            <td className="pl-0">Life Time</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/homework-list");
                              }}
                            >
                              {anserqueData &&
                                anserqueData.answerQuestionForHomeworkHelp
                                  ?.lifeTime}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card>
                  <CardBody>
                    <div className="card-title">
                      <div className="mt-2 font-weight-bold">
                        Assignment Help
                      </div>
                    </div>
                    <div className="template-demo scroll-table">
                      <table className="table table-striped mb-0">
                        <thead>
                          <tr>
                            <th className="pl-0">Today</th>
                            <th
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/assignment-list");
                              }}
                            >
                              {anserqueData &&
                                anserqueData.answerQuestionForAssignmentHelp
                                  ?.today}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="pl-0">Last 7 Days</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/assignment-list");
                              }}
                            >
                              {anserqueData &&
                                anserqueData.answerQuestionForAssignmentHelp
                                  ?.last7Days}
                            </td>
                          </tr>
                          <tr>
                            <td className="pl-0">Last 30 Days</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/assignment-list");
                              }}
                            >
                              {anserqueData &&
                                anserqueData.answerQuestionForAssignmentHelp
                                  ?.last30Days}
                            </td>
                          </tr>
                          <tr>
                            <td className="pl-0">Life Time</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/assignment-list");
                              }}
                            >
                              {anserqueData &&
                                anserqueData.answerQuestionForAssignmentHelp
                                  ?.lifeTime}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card>
                  <CardBody>
                    <div className="card-title">
                      <div className="mt-2 font-weight-bold">
                        Live Session Help
                      </div>
                    </div>
                    <div className="template-demo scroll-table">
                      <table className="table table-striped  mb-0">
                        <thead>
                          <tr>
                            <th className="pl-0">Today</th>
                            <th
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/live-session-listssssss");
                              }}
                            >
                              {anserqueData &&
                                anserqueData.answerQuestionForLiveSessionHelp
                                  ?.today}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="pl-0">Last 7 Days</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/live-session-listssssss");
                              }}
                            >
                              {anserqueData &&
                                anserqueData.answerQuestionForLiveSessionHelp
                                  ?.last7Days}
                            </td>
                          </tr>
                          <tr>
                            <td className="pl-0">Last 30 Days</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/live-session-listssssss");
                              }}
                            >
                              {anserqueData &&
                                anserqueData.answerQuestionForLiveSessionHelp
                                  ?.last30Days}
                            </td>
                          </tr>
                          <tr>
                            <td className="pl-0">Life Time</td>
                            <td
                              className="text-right font-weight-bold"
                              style={{ color: "#E541ED ", cursor: "pointer" }}
                              onClick={() => {
                                navigator("/live-session-listssssss");
                              }}
                            >
                              {anserqueData &&
                                anserqueData.answerQuestionForLiveSessionHelp
                                  ?.lifeTime}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
          <div className="answer-subCategory mt-4">
            <div className="bg-white p-2 mb-2" style={{ borderRadius: "5px" }}>
              <h5 className="page-title">Category Wise Answer Questions</h5>
            </div>
            <Row>
              <Col md="4">
                <Card>
                  <CardBody>
                    <div className="card-title">
                      <div className="mt-2 font-weight-bold">Homework Help</div>
                    </div>
                    <div className="template-demo scroll-table">
                      <table className="table table-striped mb-0">
                        <tbody>
                          {anserqueData &&
                            anserqueData.subCategoryWiseSolvedQuestionsAskedForHomeworkHelp?.map(
                              (subCategory) => (
                                <tr key={subCategory._id}>
                                  <td className="pl-0">
                                    {subCategory.subCategoryName}
                                  </td>
                                  <td
                                    className="text-right font-weight-bold"
                                    style={{
                                      color: "#E541ED ",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      navigator("/homework-list");
                                    }}
                                  >
                                    {subCategory.totalOrder}
                                  </td>
                                </tr>
                              ),
                            )}
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card>
                  <CardBody>
                    <div className="card-title">
                      <div className="mt-2 font-weight-bold">
                        Assignment Help
                      </div>
                    </div>
                    <div className="template-demo scroll-table">
                      <table className="table table-striped mb-0">
                        <tbody>
                          {anserqueData &&
                            anserqueData.subCategoryWiseSolvedQuestionsAskedForAssignmentHelp?.map(
                              (subCategory) => (
                                <tr key={subCategory._id}>
                                  <td className="pl-0">
                                    {subCategory.subCategoryName}
                                  </td>
                                  <td
                                    className="text-right font-weight-bold"
                                    style={{
                                      color: "#E541ED ",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      navigator("/assignment-list");
                                    }}
                                  >
                                    {subCategory.totalOrder}
                                  </td>
                                </tr>
                              ),
                            )}
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card>
                  <CardBody>
                    <div className="card-title">
                      <div className="mt-2 font-weight-bold">
                        Live Session Help
                      </div>
                    </div>
                    <div className="template-demo scroll-table">
                      <table className="table table-striped  mb-0">
                        <tbody>
                          {anserqueData &&
                            anserqueData.subCategoryWiseSolvedQuestionsAskedForLiveSessionHelp?.map(
                              (subCategory) => (
                                <tr key={subCategory._id}>
                                  <td className="pl-0">
                                    {subCategory.subCategoryName}
                                  </td>
                                  <td
                                    className="text-right font-weight-bold"
                                    style={{
                                      color: "#E541ED ",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      navigator("/live-session-list");
                                    }}
                                  >
                                    {subCategory.totalOrder}
                                  </td>
                                </tr>
                              ),
                            )}
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </>
      )}
    </div>
  );
};

export default Dashboard;
